import React, {useEffect, useState} from "react";
import ApiService from "../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import DonationButton from "./donation-button";
import Counter from "./counter";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro";
import {getPrimaryColor} from "../tokens";
import logger from "../../../services/logger"

export default function TeamProgressPartner({context,campagneData,campagneTarget}){

    const [teamStats,setTeamStats]=useState(null)

    const isMobile=context.isMobile

    const getTeamStats=async ()=>{
        const _id=campagneData?.id
        const _team=campagneTarget.initial.team

        logger.debug({ _team }, "team-progress-partner team")

        if(!_id || !_team){
            return false
        }

        const res=await ApiService.get("/campagne/team/stats/"+_id+"/"+_team)

        setTeamStats(res.data)
    }


    useEffect(() => {
        getTeamStats()
    }, [campagneData?.stats?.total?.count?.total]);


    if(!teamStats || !campagneTarget.initial.team){
        return null
    }

    const teamData=campagneData.teams.find(i=>i.param===campagneTarget.initial.team)

    //console.log("teamStats",teamStats)
    //console.log("teamData",teamData)

    const partnerMontant=campagneData?.partnerMontant || 1
    const teamTotal=teamStats.sum.total/partnerMontant

    const percent=(Number(teamData.objectif)>0 ? (teamTotal/teamData.objectif)*100 : 0)

    let progressColor=getPrimaryColor(campagneData.config)

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })

    let donorName=campagneData.config?.donorName || t`Parrainages`


    return(
        <div className={"container"} style={{padding:isMobile?"4rem 1rem":"4rem 0",display:"flex",flexDirection:"column",justifyContent:"center"}}>

            <span style={{fontSize:isMobile?"2rem":"3rem",fontWeight:900,textAlign:"center",width:"100%",marginBottom:"0.5rem"}}>{teamData.label}</span>

            <ProgressBar
                customLabel={" "}
                animateOnRender
                completed={percent}
                width={"100%"}
                height={"1rem"}
                bgColor={progressColor}
            />
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:"0.5rem"}}>
                <span style={{fontSize:"1rem"}}><span style={{fontWeight:700}}><Counter number={teamTotal} decimals={0}/></span> <Trans>sur</Trans> {formater.format(teamData.objectif)} {donorName}</span>
            </div>


            <div style={{display:"flex",alignItems:"center",justifyContent:"center",marginTop:"1rem"}}>
                <DonationButton context={context} />
            </div>

        </div>
    )
}
